import * as React from 'react';
import style from './Overlays.module.css';

interface DownloadOverlayProps {
  progress: number;
  status: 'downloading' | 'complete' | 'error';
  onRetry?: () => void;
}

export function DownloadOverlay({
  progress,
  status,
  onRetry,
}: DownloadOverlayProps) {
  if (status === 'error') {
    return (
      <div className={style.overlay} role="alert" aria-live="assertive">
        <div className={style.content}>
          <p className={style.title}>Oops! Update didn't finish</p>
          <p className={style.message}>
            We couldn't download the update. Please check your connection and
            try again, or restart the app.
          </p>
          {onRetry && (
            <button
              type="button"
              className={style.retryButton}
              onClick={onRetry}
            >
              Retry
            </button>
          )}
        </div>
      </div>
    );
  }

  if (status === 'complete') {
    return (
      <div className={style.overlay} role="status" aria-live="polite">
        <div className={style.content}>
          <p className={style.title}>Update ready</p>
          <p className={style.message}>
            You're on the latest version. Restarting the app…
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className={style.overlay} role="progressbar" aria-valuenow={progress}>
      <div className={style.content}>
        <p className={style.title}>Updating Peace Game...</p>
        <p className={style.message}>
          We're downloading the latest updates to make things better. This
          should only take a moment.
        </p>
        <div className={style.progressTrack}>
          <div
            className={style.progressBar}
            style={{ width: `${Math.min(100, Math.max(0, progress))}%` }}
          />
        </div>
        <p className={style.percent}>{Math.round(progress)}%</p>
      </div>
    </div>
  );
}

interface MaintenanceOverlayProps {
  onRetry?: () => void;
}

export function MaintenanceOverlay({ onRetry }: MaintenanceOverlayProps) {
  return (
    <div className={style.overlay} role="alert" aria-live="polite">
      <div className={style.content}>
        <p className={style.title}>We'll Be Right Back</p>
        <p className={style.message}>
          We're doing a little maintenance to keep things running smoothly.
          Please check back in a few minutes.
        </p>
        {onRetry && (
          <button type="button" className={style.retryButton} onClick={onRetry}>
            Retry
          </button>
        )}
      </div>
    </div>
  );
}
